import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const CLIENT_API = `${BACKEND_URL}/api`;

export const clientApi = axios.create({ baseURL: CLIENT_API });

clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("bg_client_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setClientToken = (t) => {
  if (t) localStorage.setItem("bg_client_token", t);
  else localStorage.removeItem("bg_client_token");
};

export const getClientToken = () => localStorage.getItem("bg_client_token");
